export default  {
    mainHeadText: {
        //height: "33px",
        //width: "216px",
        color: "#58595B",
        fontFamily: "Open Sans",
        fontSize: "24px",
        fontWeight: "600",
        letterSpacing: "0",
        lineHeight: "33px",
    },
    activeTabText: {
        //height: "19px",
        //width: "187px",
        color: "#1B75BC",
        fontFamily: "Open Sans",
        fontSize: "14px",
        fontWeight: "600",
        letterSpacing: "0",
        lineHeight: "19px",
        textAlign: "center",
    },
    nonActiveTabText: {
        //height: "19px",
        //width: "150px",
        color: "#58595B",
        fontFamily: "Open Sans",
        fontSize: "14px",
        letterSpacing: "0",
        lineHeight: "19px",
        textAlign: "center",
    },
    userNameText: {
        //height: "19px",
        //width: "57px",
        color: "#1B75BC",
        fontFamily: "Open Sans",
        fontSize: "14px",
        fontWeight: "600",
        letterSpacing: "0",
        lineHeight: "19px",
    },

    sessionHourText: {
        height: "17px",
        width: "41px",
        opacity: "0.7",
        color: "#58595B",
        fontFamily: "Open Sans",
        fontSize: "12px",
        fontStyle: "italic",
        letterSpacing: "0",
        lineHeight: "17px",
        fontWeight: "600",
    },
    noDatasessionHourText: {
        opacity: "0.7",
        color: "#58595B",
        fontFamily: "Open Sans",
        fontSize: "14px",
        fontStyle: "italic",
        letterSpacing: "0",
        lineHeight: "17px",
        textAlign: "center",
        maxWidth: "380px",
        marginTop: "15px",
    },
    bottomNote: {
        backgroundColor: "#E8F1F8",
    },
    bottomNoteText: {
        //height: "19px",
        //width: "353px",
        color: "#58595B",
        fontFamily: "Open Sans",
        fontSize: "14px",
        fontWeight: "600",
        letterSpacing: "0",
        lineHeight: "19px",
        textAlign: "center",
    },
    selectedRadioBgColor: {
        background: "#E8F1F8",
    },
    selectAllCheckBoxText: {
        //height: "19px",
        //width: "76px",
        color: "#58595B",
        fontFamily: "Open Sans",
        fontSize: "14px",
        fontWeight: "600",
        letterSpacing: "0",
        lineHeight: "19px",
    },
    heartImage: {
        height: "21px",
        width: "24px",
    },
    optionMenu: {
        height: "4px",
        width: "18px",
    },
};